import { OcrResult } from "../api/index";

function validateKorean(value: string) {
  if (!value.length) {
    return false;
  }
  const koreanRegex = /[a-z0-9]|[[\]{}()<>?|`~!@#$%^&*-_+=,.;:"'\\]/g;
  return !koreanRegex.test(value);
}

interface MapDictionary {
  [key: string]: RegExp;
}

const idCardVerificationMap1: MapDictionary = {
  대학교: /대학/g,
  고등학교: /고등학교/g,
  // 중학교: /중학교/g,
};

const idCardVerificationMap2: MapDictionary = {
  대학교: /univ/g,
  고등학교: /high/g,
  // 중학교: /middle/g,
};

// TODO: 입력받은 대학교 이름도 유효성 검사 로직에 추가할 수 있게 구현
function validateStudentCard(
  results: OcrResult[],
  studentName: string,
  schoolType: string,
) {
  const recognitionWords = results
    .map((result) => result.recognition_words[0])
    .map((word) => word.toLocaleLowerCase().replace(/\s+/g, ""));
  // console.log(recognitionWords);
  const re1 = idCardVerificationMap1[schoolType];
  const re2 = idCardVerificationMap2[schoolType];
  const schoolTypeVerified =
    recognitionWords.findIndex((word) => re1.test(word) || re2.test(word)) !==
    -1;
  const studentNameVerified =
    recognitionWords.findIndex((word) => word === studentName) !== -1;
  // console.log(schoolTypeVerified, studentNameVerified);
  return schoolTypeVerified && studentNameVerified;
}

function loadFromStorage(key: string) {
  return sessionStorage.getItem(key);
}

function saveToStorage(key: string, value: string) {
  sessionStorage.setItem(key, value);
}

function formatBytes(bytes: number, decimals = 2): string {
  if (bytes === 0) {
    return "0 Bytes";
  }
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + sizes[i];
}

export {
  validateKorean,
  validateStudentCard,
  saveToStorage,
  loadFromStorage,
  formatBytes,
};
